import { useDispatch } from "react-redux"
import { IdeaAttachement } from "../../components/ideaAttachment/ideaAttachment.component"
import { popupModelDataActions } from "../../store/popupModelData"

export const IdeaAttachmentList = ({ attachments }) => {

    const dispatch = useDispatch()

    const setAttachmentsToListModel = (index) => {
        dispatch(popupModelDataActions.setIndex(index))
        dispatch(popupModelDataActions.setData(attachments))
    }

    return (
        <div className="row">
            {attachments.map((attachment, index) => {

                if (attachments.length == 1) {
                    return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-12"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                }
                else if (attachments.length == 2) {
                    return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-6"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                }
                else if (attachments.length == 3) {
                    if (index == 0) {
                        return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-12"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                    }
                    else {
                        return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-6"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                    }
                }
                else if (attachments.length >= 4) {
                    if (index == 0) {
                        return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-12"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                    }
                    else if (index == 1 || index === 2) {
                        return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-4"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                    }
                    else if (index == 3) {
                        if (attachments.length > 4) {
                            return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-4"} link={attachment.ATTACHMENT} attachmentIndex={index} remainingCount={attachments.length - 3} setAttachmentsToListModel={setAttachmentsToListModel}/>
                        } else {
                            return <IdeaAttachement key={index} type={attachment.ATTACHMENT_TYPE} size={"col-4"} link={attachment.ATTACHMENT} attachmentIndex={index} setAttachmentsToListModel={setAttachmentsToListModel}/>
                        }
                    }
                }
            })}
        </div>
    )
}